//PACKAGES
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";

//CONSTANTS & ASSETS
import { STRING, STRINGS } from "../../constant";

//COMPONENTS
import { Header, LAView, LAText, LATextInput, LAButton } from "../../components";
import CommonHeader from "../../components/common/CommonHeader";
import { ProfileInfo, AccountInfo, AccountActions } from "./components/account";

//API
import {
  DELETE_BUNDLE_USER,
  DELETE_USER,
  GET_STORE_AUTH_DETAILS,
  UPDATE_PROFILE_DETAILS,
} from "../../api/firebase_user";

//PACKAGES
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import IconTint from "react-icon-tint";
import { auth } from "../../api/config";
import { IS_BUNDLE_APP } from "../../../app_constant";
import { AuthContext } from "../../context/AuthProvider";
import { SHOW_TOAST } from "../../constant/utils";
import BackArrowIcon from "../../components/BackArrowIcon";
import { ThemeContext } from "../../context/ThemeProvider";

function Account() {
  const navigation = useNavigate();
  const { bundleData, profile, setProfileDetails, isSubscribe } =
    useContext(AuthContext);

  const { theme, currentTheme } = useContext(ThemeContext);
  const [editble, setEditable] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(
    IS_BUNDLE_APP
      ? bundleData?.auth_first_name ?? ""
      : profile?.auth_first_name ?? ""
  );
  const [lastName, setLastName] = useState(
    IS_BUNDLE_APP
      ? bundleData?.auth_last_name ?? ""
      : profile?.auth_last_name ?? ""
  );
  const [email, setEmail] = useState(
    IS_BUNDLE_APP ? bundleData?.auth_email ?? "" : profile?.auth_email ?? ""
  );

  const [loginMethod, setLoginMethod] = useState(
    IS_BUNDLE_APP
      ? bundleData?.auth_login_provider ?? ""
      : profile?.auth_login_provider ?? ""
  );

  function getLoginMethod() {
    if (loginMethod == "google.com") {
      return "Sign in with Google";
    } else if (loginMethod == "apple.com") {
      return "Sign in with Apple";
    } else {
      return "Sign in with Email";
    }
  }

  function isEmailLogin() {
    if (loginMethod == "google.com") {
      return false;
    } else if (loginMethod == "apple.com") {
      return false;
    } else {
      return true;
    }
  }

  async function onSave() {
    // Regular expression for validating names (only letters, no spaces, numbers, or symbols)
    const nameRegex = /^[A-Za-z]+$/;
    // Keyboard.dismiss();
    if (!firstName.trim()) {
      SHOW_TOAST(STRING.enter_first_name, "error");
    } else if (!lastName.trim()) {
      SHOW_TOAST(STRING.enter_last_name, "error");
    } else if (!nameRegex.test(firstName)) {
      SHOW_TOAST("Invalid first name", "error");
    } else if (!nameRegex.test(lastName)) {
      SHOW_TOAST("Invalid last name", "error");
    } else {
      setProfileDetails(firstName, lastName);

      // const result = await UPDATE_PROFILE_DETAILS(firstName, lastName);

      navigation(-1);
    }
  }

  async function onSignuOut() {
    setLoading(true);
    await auth().signOut();
    // localStorage.clear();
    setLoading(false);

    navigation("/login");
    localStorage.removeItem("appState");
  }

  async function deleteAccount() {
    setLoading(true);
    try {
    } catch (err) {
      console.error(err);
    }
    const uid = auth().currentUser?.uid;
    const provider = auth().currentUser?.providerData[0]?.providerId ?? "";
    const result = await DELETE_USER(uid);
    if (IS_BUNDLE_APP) {
      try {
        await DELETE_BUNDLE_USER(uid);
        localStorage.clear();
        navigation("/login");
      } catch (err) {
        console.error(err);
      }
    }
    try {
      const resultApps = await GET_STORE_AUTH_DETAILS();
      if (result.status == true) {
        setLoading(false);
        if (resultApps.status) {
          if (resultApps?.data?.apps?.length <= 1) {
            await auth().currentUser.delete();
          }
        }

        SHOW_TOAST("Your account has been deleted successfully", "success");
        localStorage.clear();
        navigation("/login");
      } else {
        setLoading(false);
        setTimeout(() => {
          SHOW_TOAST(result.error, "error");
        }, 1000);
      }
    } catch (e) {
      setLoading(false);
      setTimeout(() => {
        authError(e);
      }, 1000);
    }
    await onSignuOut();
  }

  function authError(error) {
    if (error.code == "auth/requires-recent-login") {
      // Alert.alert('', 'This operation is sensitive and requires recent authentication. Log in again before retrying this request. Logout and Login again to delete your account', [
      //     { text: STRING.cancel, style: 'cancel', onPress: () => { } },
      //     {
      //         text: STRING.sign_out, style: 'destructive', onPress: () => {
      //             onSignuOut()
      //         }
      //     }
      // ])
    } else {
      // Alert.alert("", error.message);
    }
  }

  const handleSubmit = (value) => {
    
    setProfileDetails(value?.first_name, value?.last_name);

    SHOW_TOAST("Profile updated successfully", "success");
    navigation(-1);
  };

  const onEditProfileInfo = () => {
    setEditable(!editble);
  };

  function getLoginMethod() {
    if (loginMethod == "google.com") {
      return "Sign in with Google";
    } else if (loginMethod == "apple.com") {
      return "Sign in with Apple";
    } else {
      return "Sign in with Email";
    }
  }

  const loginType = getLoginMethod();

  const styles = {
    container: {
      padding: '1.5rem',
      margin: '0 auto',
      maxWidth: '1200px',
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '1.5rem',
      marginBottom: '1.5rem',
    },
    gridContainerLg: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '1.5rem',
      marginBottom: '1.5rem',
    },
  };

  return (
    <div style={styles.container}>
      <CommonHeader
        title="Account Settings"
        subtitle="Manage your profile and account preferences"
        quote="Your account, your control. Secure and personalized."
        onBack={() => navigation(-1)}
        theme={theme}
        showBackButton={true}
      />

      
      <div className="mt-12 lg:flex lg:gap-12 lg:items-stretch">
        <div className="lg:flex-1">
          <ProfileInfo
            firstName={firstName}
            lastName={lastName}
            isLoading={isLoading}
            theme={theme}
            onSave={handleSubmit}
          />
        </div>
        <div className="lg:flex-1 lg:mt-0 mt-8">
          <AccountInfo
            email={email}
            profile={profile}
            loginType={loginType}
            theme={theme}
          />
        </div>
      </div>
      <div className="mt-12 lg:w-1/2 lg:mx-auto">
        <AccountActions
          isLoading={isLoading}
          theme={theme}
          onSignOut={onSignuOut}
          onDeleteAccount={deleteAccount}
        />
      </div>
    </div>
  );
}

export default Account;
